import { render } from "./teamlead.vue?vue&type=template&id=6cb4d278"
import script from "./teamlead.vue?vue&type=script&lang=js"
export * from "./teamlead.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__